module.exports = __webpack_public_path__ + "media/ppc/us-news-65c47d66.png";